import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Solutions } from './pages/Solutions';
import { WhatWeDo } from './pages/WhatWeDo';
import { Diagnostic } from './pages/Diagnostic';
import { Intelligence } from './pages/Intelligence';
import { AboutUs } from './pages/AboutUs';
import { Contact } from './pages/Contact';
import { NotFound } from './pages/NotFound';

// Helper to scroll to top on route navigation
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const App: React.FC = () => {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <Navbar />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/solutions" element={<Solutions />} />
              <Route path="/solutions/" element={<Solutions />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/what-we-do/" element={<WhatWeDo />} />
              <Route path="/diagnostic" element={<Diagnostic />} />
              <Route path="/diagnostic/" element={<Diagnostic />} />
              <Route path="/intelligence" element={<Intelligence />} />
              <Route path="/intelligence/" element={<Intelligence />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/about-us/" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/contact/" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
};

export default App;
